webpackJsonp([10],{

/***/ 1101:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppearanceEdit_vue__ = __webpack_require__(1236);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21152104_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppearanceEdit_vue__ = __webpack_require__(1310);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppearanceEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21152104_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppearanceEdit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1137:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_AppButton__ = __webpack_require__(92);
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MobileSubmitButton',
  components: {
    AppButton: __WEBPACK_IMPORTED_MODULE_0__components_AppButton__["a" /* default */]
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    noBottom: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ 1144:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Base_FGroup__ = __webpack_require__(75);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function formatSize(bytes) {
  if (bytes >= 1048576) return "".concat((bytes / 1048576).toFixed(0), " MB");
  return "".concat((bytes / 1024).toFixed(0), " KB");
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FFile',
  components: {
    FGroup: __WEBPACK_IMPORTED_MODULE_0__Base_FGroup__["a" /* default */]
  },
  props: {
    label: String,
    id: {
      type: String,
      required: true
    },
    accept: String,
    required: Boolean,
    displayName: String,
    isInvalid: Boolean,
    tooltip: String,
    hint: String,
    maxSize: {
      type: Number,
      default: 1048576
    }
  },
  data: function data() {
    return {
      fileName: this.displayName || '',
      validationError: null
    };
  },
  watch: {
    displayName: function displayName(val) {
      this.fileName = val || '';
    }
  },
  methods: {
    onChange: function onChange(event) {
      var file = event.target.files[0];

      if (!file) {
        this.validationError = null;
        this.fileName = '';
        return;
      }

      var sizeError = this.validateSize(file);

      if (sizeError) {
        this.validationError = sizeError;
        this.fileName = '';
        this.$refs.input.value = '';
        return;
      }

      var typeError = this.validateType(file);

      if (typeError) {
        this.validationError = typeError;
        this.fileName = '';
        this.$refs.input.value = '';
        return;
      }

      this.validationError = null;
      this.fileName = file.name;
      this.$emit('change', event);
    },
    validateSize: function validateSize(file) {
      if (file.size > this.maxSize) {
        return "File is too large. Maximum size is ".concat(formatSize(this.maxSize), ".");
      }

      return null;
    },
    validateType: function validateType(file) {
      if (!this.accept) return null;
      var tokens = this.accept.split(',').map(function (t) {
        return t.trim().toLowerCase();
      });
      var fileExt = file.name.split('.').pop().toLowerCase();
      var allowed = tokens.some(function (token) {
        var normalized = token.startsWith('.') ? token : ".".concat(token);

        if (normalized.includes('/')) {
          return token.endsWith('/*') ? file.type.startsWith(token.slice(0, -1)) : file.type === token;
        }

        return file.name.toLowerCase().endsWith(normalized) || fileExt === token.replace(/^\./, '');
      });

      if (!allowed) {
        var exts = tokens.map(function (t) {
          return t.startsWith('.') ? t.slice(1) : t;
        }).join(', ');
        return "Invalid file type. Allowed: ".concat(exts, ".");
      }

      return null;
    }
  }
});

/***/ }),

/***/ 1145:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FImagePreview',
  props: {
    src: {
      type: String,
      default: null
    },
    alt: {
      type: String,
      default: ''
    },
    deletable: {
      type: Boolean,
      default: false
    },
    deleting: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loading: !!this.src
    };
  },
  watch: {
    src: function src(val) {
      this.loading = !!val;
    }
  }
});

/***/ }),

/***/ 1147:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useScrollToError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);

function useScrollToError(errors) {
  Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(errors, function () {
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["f" /* nextTick */])(function () {
      var first = document.querySelector('.is-invalid');

      if (first) {
        first.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    });
  });
}

/***/ }),

/***/ 1148:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileSubmitButton_vue__ = __webpack_require__(1137);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6370764f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileSubmitButton_vue__ = __webpack_require__(1149);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileSubmitButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6370764f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileSubmitButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1149:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['d-lg-none mt-3', _vm.noBottom ? '' : 'mb-4']},[_c('app-button',{attrs:{"type":"submit","loading":_vm.loading}},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1154:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(26);

/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(frame) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/appearances/".concat(frame));
  },
  update: function update(frame, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].put("/v2/appearances/".concat(frame), data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      silent: true
    });
  },
  reset: function reset(frame) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].delete("/v2/appearances/".concat(frame), {
      silent: true
    });
  },
  deleteField: function deleteField(frame, key) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].delete("/v2/appearances/".concat(frame, "/").concat(key), {
      silent: true
    });
  }
});

/***/ }),

/***/ 1159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = defaultForm;
/* harmony export (immutable) */ __webpack_exports__["d"] = defaultPreviews;
/* harmony export (immutable) */ __webpack_exports__["a"] = applyResponse;
/* harmony export (immutable) */ __webpack_exports__["b"] = useAppearance;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_appearances__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(1160);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }




function defaultForm(config) {
  var form = {
    schema_color: '#aa2d41',
    sponsor_link: ''
  };

  if (config.hasLogoLinks) {
    for (var i = 1; i <= config.logoCount; i += 1) {
      form["sponsor_logo_".concat(i, "_link")] = '';
    }
  }

  return form;
}
function defaultPreviews(config) {
  var previews = {};
  config.fileKeys.forEach(function (key) {
    previews[key] = null;
  });
  return previews;
}
function applyResponse(form, previews, data, config) {
  form.schema_color = data.schema_color != null ? data.schema_color : '#aa2d41';
  form.sponsor_link = data.sponsor_link != null ? data.sponsor_link : '';

  if (config.hasLogoLinks) {
    for (var i = 1; i <= config.logoCount; i += 1) {
      var linkKey = "sponsor_logo_".concat(i, "_link");
      form[linkKey] = data[linkKey] != null ? data[linkKey] : '';
    }
  }

  config.fileKeys.forEach(function (key) {
    previews[key] = data[key] != null ? data[key] : null;
  });
}
function useAppearance(frameArg) {
  var frameRef = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["e" /* isRef */])(frameArg) ? frameArg : Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(frameArg);
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
    return __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* FRAME_CONFIG */][frameRef.value];
  });
  var loading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var form = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["k" /* reactive */])(defaultForm(config.value));
  var previews = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["k" /* reactive */])(defaultPreviews(config.value));

  function fetch() {
    return _fetch.apply(this, arguments);
  }

  function _fetch() {
    _fetch = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              loading.value = true;
              _context.prev = 1;
              _context.next = 4;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_appearances__["a" /* default */].get(frameRef.value);

            case 4:
              res = _context.sent;
              applyResponse(form, previews, res.data.data, config.value);

            case 6:
              _context.prev = 6;
              loading.value = false;
              return _context.finish(6);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1,, 6, 9]]);
    }));
    return _fetch.apply(this, arguments);
  }

  Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(frameRef, function () {
    Object.assign(form, defaultForm(config.value));
    Object.assign(previews, defaultPreviews(config.value));
    fetch();
  });
  Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(fetch);
  return {
    loading: loading,
    form: form,
    previews: previews,
    config: config,
    fetch: fetch
  };
}

/***/ }),

/***/ 1160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LEADERBOARD_FILE_KEYS */
/* unused harmony export NOMINATIONS_FILE_KEYS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FRAME_CONFIG; });
var LEADERBOARD_FILE_KEYS = ['sponsor_logo_1', 'sponsor_logo_2', 'sponsor_logo_3', 'sponsor_logo_desktop', 'sponsor_logo_mobile'];
var NOMINATIONS_FILE_KEYS = ['sponsor_logo_1', 'sponsor_logo_2', 'sponsor_logo_desktop', 'sponsor_logo_mobile'];
var FRAME_CONFIG = {
  leaderboard: {
    title: 'Leaderboard Appearance',
    logoCount: 3,
    hasLogoLinks: true,
    fileKeys: LEADERBOARD_FILE_KEYS
  },
  nominations: {
    title: 'Nominations Appearance',
    logoCount: 2,
    hasLogoLinks: false,
    fileKeys: NOMINATIONS_FILE_KEYS
  }
};

/***/ }),

/***/ 1167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FColor',
  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    value: {
      type: String,
      default: '#000000'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: null
    },
    showHex: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ 1172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FFile_vue__ = __webpack_require__(1144);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64a4f5fa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FFile_vue__ = __webpack_require__(1173);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FFile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64a4f5fa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FFile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1173:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f-group',{attrs:{"label":_vm.label,"hint":_vm.hint}},[_c('div',{staticClass:"custom-file"},[_c('input',{ref:"input",class:['custom-file-input font-weight-normal', { 'is-invalid': _vm.isInvalid || !!_vm.validationError }],attrs:{"type":"file","id":_vm.id,"accept":_vm.accept,"required":_vm.required},on:{"change":_vm.onChange}}),_vm._v(" "),_c('label',{staticClass:"custom-file-label font-weight-normal",attrs:{"for":_vm.id}},[_vm._v("\n      "+_vm._s(_vm.fileName || 'Select File')+"\n    ")]),_vm._v(" "),(_vm.validationError)?_c('div',{staticClass:"invalid-tooltip"},[_vm._v(_vm._s(_vm.validationError))]):(_vm.tooltip)?_c('div',{staticClass:"invalid-tooltip"},[_vm._v(_vm._s(_vm.tooltip))]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1174:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FImagePreview_vue__ = __webpack_require__(1145);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c9ef1fd_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FImagePreview_vue__ = __webpack_require__(1177);
function injectStyle (ssrContext) {
  __webpack_require__(1175)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c9ef1fd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FImagePreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c9ef1fd_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FImagePreview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1175:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1176);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("725c5495", content, true, {});

/***/ }),

/***/ 1176:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".f-image-preview__spinner[data-v-6c9ef1fd]{display:flex;align-items:center;justify-content:center;height:80px}.f-image-preview__wrap[data-v-6c9ef1fd]{position:relative;display:inline-block;width:auto;max-width:100%}.f-image-preview__delete[data-v-6c9ef1fd]{position:absolute;top:0;right:0;width:30px;height:30px;padding:0;border:none;background-color:transparent;background-image:url(\"data:image/svg+xml;charset=UTF-8,%3csvg width='30' height='30' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3crect x='0.5' y='0.5' width='29' height='29' rx='14.5' fill='white'/%3e%3cg clip-path='url(%23clip0)'%3e%3cpath d='M20.55 20.95C20.45 20.95 20.25 20.95 20.15 20.85L10.15 10.85C9.95 10.65 9.95 10.35 10.15 10.15C10.35 9.95 10.65 9.95 10.85 10.15L20.85 20.15C21.05 20.35 21.05 20.65 20.85 20.85C20.85 20.95 20.65 20.95 20.55 20.95Z' fill='%23A2A0A0'/%3e%3cpath d='M10.55 20.95C10.45 20.95 10.25 20.95 10.15 20.85C9.95 20.65 9.95 20.35 10.15 20.15L20.15 10.15C20.35 9.95 20.65 9.95 20.85 10.15C21.05 10.35 21.05 10.65 20.85 10.85L10.85 20.85C10.85 20.95 10.65 20.95 10.55 20.95Z' fill='%23A2A0A0'/%3e%3c/g%3e%3crect x='0.5' y='0.5' width='29' height='29' rx='14.5' stroke='%23A2A0A0'/%3e%3cdefs%3e%3cclipPath id='clip0'%3e%3crect width='11' height='11' fill='white' transform='translate(10 10)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e\");background-size:contain;background-repeat:no-repeat;cursor:pointer}.f-image-preview__delete[data-v-6c9ef1fd]:disabled{cursor:not-allowed;opacity:.7}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/FormFields/FImagePreview.vue"],"names":[],"mappings":"AACA,2CACE,aAAc,AACd,mBAAoB,AACpB,uBAAwB,AACxB,WAAa,CACd,AACD,wCACE,kBAAmB,AACnB,qBAAsB,AACtB,WAAY,AACZ,cAAgB,CACjB,AACD,0CACE,kBAAmB,AACnB,MAAO,AACP,QAAS,AACT,WAAY,AACZ,YAAa,AACb,UAAW,AACX,YAAa,AACb,6BAA8B,AAC9B,69BAA89B,AAC99B,wBAAyB,AACzB,4BAA6B,AAC7B,cAAgB,CACjB,AACD,mDACE,mBAAoB,AACpB,UAAa,CACd","file":"FImagePreview.vue","sourcesContent":["\n.f-image-preview__spinner[data-v-6c9ef1fd] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 80px;\n}\n.f-image-preview__wrap[data-v-6c9ef1fd] {\n  position: relative;\n  display: inline-block;\n  width: auto;\n  max-width: 100%;\n}\n.f-image-preview__delete[data-v-6c9ef1fd] {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 30px;\n  height: 30px;\n  padding: 0;\n  border: none;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg width='30' height='30' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3crect x='0.5' y='0.5' width='29' height='29' rx='14.5' fill='white'/%3e%3cg clip-path='url(%23clip0)'%3e%3cpath d='M20.55 20.95C20.45 20.95 20.25 20.95 20.15 20.85L10.15 10.85C9.95 10.65 9.95 10.35 10.15 10.15C10.35 9.95 10.65 9.95 10.85 10.15L20.85 20.15C21.05 20.35 21.05 20.65 20.85 20.85C20.85 20.95 20.65 20.95 20.55 20.95Z' fill='%23A2A0A0'/%3e%3cpath d='M10.55 20.95C10.45 20.95 10.25 20.95 10.15 20.85C9.95 20.65 9.95 20.35 10.15 20.15L20.15 10.15C20.35 9.95 20.65 9.95 20.85 10.15C21.05 10.35 21.05 10.65 20.85 10.85L10.85 20.85C10.85 20.95 10.65 20.95 10.55 20.95Z' fill='%23A2A0A0'/%3e%3c/g%3e%3crect x='0.5' y='0.5' width='29' height='29' rx='14.5' stroke='%23A2A0A0'/%3e%3cdefs%3e%3cclipPath id='clip0'%3e%3crect width='11' height='11' fill='white' transform='translate(10 10)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  cursor: pointer;\n}\n.f-image-preview__delete[data-v-6c9ef1fd]:disabled {\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"f-image-preview mb-3 pt-3"},[(_vm.loading)?_c('div',{staticClass:"f-image-preview__spinner"},[_c('div',{staticClass:"spinner-border spinner-border-sm text-secondary"})]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],staticClass:"f-image-preview__wrap"},[(_vm.src)?_c('img',{staticClass:"w-100",staticStyle:{"max-height":"400px","object-fit":"contain"},attrs:{"src":_vm.src,"alt":_vm.alt},on:{"load":function($event){_vm.loading = false},"error":function($event){_vm.loading = false}}}):_vm._e(),_vm._v(" "),(_vm.deletable)?_c('button',{staticClass:"f-image-preview__delete",attrs:{"type":"button","disabled":_vm.deleting},on:{"click":function($event){return _vm.$emit('delete')}}}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1205:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FColor_vue__ = __webpack_require__(1167);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65d791a7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FColor_vue__ = __webpack_require__(1206);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FColor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65d791a7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FColor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{staticClass:"d-flex align-items-center"},[_c('input',{staticClass:"form-control",staticStyle:{"max-width":"68px","height":"32px","padding":"2px 4px","cursor":"pointer"},attrs:{"id":_vm.id,"type":"color","disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}}),_vm._v(" "),(_vm.showHex)?_c('span',{staticClass:"ml-3 text-muted"},[_vm._v(_vm._s(_vm.value))]):_vm._e()]),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"invalid-tooltip d-block"},[_vm._v("\n    "+_vm._s(_vm.error)+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeading__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FormFields_FFile__ = __webpack_require__(1172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FormFields_FText__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FormFields_FImagePreview__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_FormFields_FColor__ = __webpack_require__(1205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_MobileSubmitButton__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_AppButton__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_DesktopActionBar__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_api_appearances__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__composables_appearances_useAppearance__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__composables_appearances_useAppearanceForm__ = __webpack_require__(1309);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'AppearanceEdit',
  components: {
    'tab-layout': __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__["a" /* default */],
    'page-heading': __WEBPACK_IMPORTED_MODULE_2__components_PageHeading__["a" /* default */],
    FFile: __WEBPACK_IMPORTED_MODULE_3__components_FormFields_FFile__["a" /* default */],
    FText: __WEBPACK_IMPORTED_MODULE_4__components_FormFields_FText__["a" /* default */],
    FImagePreview: __WEBPACK_IMPORTED_MODULE_5__components_FormFields_FImagePreview__["a" /* default */],
    FColor: __WEBPACK_IMPORTED_MODULE_6__components_FormFields_FColor__["a" /* default */],
    MobileSubmitButton: __WEBPACK_IMPORTED_MODULE_7__components_MobileSubmitButton__["a" /* default */],
    AppButton: __WEBPACK_IMPORTED_MODULE_8__components_AppButton__["a" /* default */],
    DesktopActionBar: __WEBPACK_IMPORTED_MODULE_9__components_DesktopActionBar__["a" /* default */]
  },
  props: {
    frame: {
      type: String,
      required: true
    }
  },
  setup: function setup(props) {
    var frameRef = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["a" /* computed */])(function () {
      return props.frame;
    });

    var _useAppearance = Object(__WEBPACK_IMPORTED_MODULE_11__composables_appearances_useAppearance__["b" /* default */])(frameRef),
        loading = _useAppearance.loading,
        form = _useAppearance.form,
        previews = _useAppearance.previews,
        config = _useAppearance.config;

    var _useAppearanceForm = Object(__WEBPACK_IMPORTED_MODULE_12__composables_appearances_useAppearanceForm__["a" /* default */])(frameRef, form, previews),
        submitting = _useAppearanceForm.submitting,
        resetting = _useAppearanceForm.resetting,
        errors = _useAppearanceForm.errors,
        save = _useAppearanceForm.save,
        reset = _useAppearanceForm.reset;

    var allFileKeys = ['sponsor_logo_1', 'sponsor_logo_2', 'sponsor_logo_3', 'sponsor_logo_desktop', 'sponsor_logo_mobile'];

    var emptyFileMap = function emptyFileMap() {
      var map = {};
      allFileKeys.forEach(function (key) {
        map[key] = null;
      });
      return map;
    };

    var localFiles = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["k" /* reactive */])(emptyFileMap());
    var localPreviews = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["k" /* reactive */])(emptyFileMap());

    function clearLocalFiles() {
      allFileKeys.forEach(function (key) {
        if (localPreviews[key]) URL.revokeObjectURL(localPreviews[key]);
        localPreviews[key] = null;
        localFiles[key] = null;
      });
    }

    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(loading, function (isLoading) {
      if (!isLoading) return;
      clearLocalFiles();
    });
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["p" /* watch */])(frameRef, clearLocalFiles);

    function onFileChange(key, event) {
      var file = event.target.files[0];
      if (!file) return;
      localFiles[key] = file;
      if (localPreviews[key]) URL.revokeObjectURL(localPreviews[key]);
      localPreviews[key] = URL.createObjectURL(file);
    }

    var deletingKey = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);

    function deleteImage(_x) {
      return _deleteImage.apply(this, arguments);
    }

    function _deleteImage() {
      _deleteImage = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(key) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                deletingKey.value = key;
                _context.prev = 1;
                _context.next = 4;
                return __WEBPACK_IMPORTED_MODULE_10__services_api_appearances__["a" /* default */].deleteField(frameRef.value, key);

              case 4:
                previews[key] = null;

              case 5:
                _context.prev = 5;
                deletingKey.value = null;
                return _context.finish(5);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1,, 5, 8]]);
      }));
      return _deleteImage.apply(this, arguments);
    }

    function handleSubmit() {
      return _handleSubmit.apply(this, arguments);
    }

    function _handleSubmit() {
      _handleSubmit = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var ok;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return save(localFiles);

              case 2:
                ok = _context2.sent;
                if (ok) clearLocalFiles();

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _handleSubmit.apply(this, arguments);
    }

    function handleReset() {
      return _handleReset.apply(this, arguments);
    }

    function _handleReset() {
      _handleReset = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return reset();

              case 2:
                clearLocalFiles();

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
      return _handleReset.apply(this, arguments);
    }

    return {
      loading: loading,
      submitting: submitting,
      resetting: resetting,
      errors: errors,
      form: form,
      previews: previews,
      config: config,
      localFiles: localFiles,
      localPreviews: localPreviews,
      deletingKey: deletingKey,
      onFileChange: onFileChange,
      deleteImage: deleteImage,
      handleSubmit: handleSubmit,
      handleReset: handleReset
    };
  }
}));

/***/ }),

/***/ 1309:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useAppearanceForm;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_appearances__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__composables_useScrollToError__ = __webpack_require__(1147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__useAppearance__ = __webpack_require__(1159);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }






function useAppearanceForm(frameArg, form, previews) {
  var frameRef = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["e" /* isRef */])(frameArg) ? frameArg : Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(frameArg);
  var submitting = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var resetting = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var errors = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])({});
  Object(__WEBPACK_IMPORTED_MODULE_2__composables_useScrollToError__["a" /* default */])(errors);

  function save(_x) {
    return _save.apply(this, arguments);
  }

  function _save() {
    _save = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(files) {
      var config, formData, i, res, data;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              config = __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* FRAME_CONFIG */][frameRef.value];
              submitting.value = true;
              errors.value = {};
              _context.prev = 3;
              formData = new FormData();
              formData.append('schema_color', form.schema_color);
              formData.append('sponsor_link', form.sponsor_link);

              if (config.hasLogoLinks) {
                for (i = 1; i <= config.logoCount; i += 1) {
                  formData.append("sponsor_logo_".concat(i, "_link"), form["sponsor_logo_".concat(i, "_link")]);
                }
              }

              config.fileKeys.forEach(function (key) {
                if (files[key]) formData.append(key, files[key]);
              });
              _context.next = 11;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_appearances__["a" /* default */].update(frameRef.value, formData);

            case 11:
              res = _context.sent;
              Object(__WEBPACK_IMPORTED_MODULE_4__useAppearance__["a" /* applyResponse */])(form, previews, res.data.data, config);
              return _context.abrupt("return", true);

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](3);
              data = _context.t0.response != null ? _context.t0.response.data : null;

              if (data != null && data.code === 'validation_error') {
                errors.value = data.errors;
              }

              return _context.abrupt("return", false);

            case 21:
              _context.prev = 21;
              submitting.value = false;
              return _context.finish(21);

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 16, 21, 24]]);
    }));
    return _save.apply(this, arguments);
  }

  function reset() {
    return _reset.apply(this, arguments);
  }

  function _reset() {
    _reset = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2() {
      var config;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              config = __WEBPACK_IMPORTED_MODULE_3__constants__["a" /* FRAME_CONFIG */][frameRef.value];
              resetting.value = true;
              _context2.prev = 2;
              _context2.next = 5;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_appearances__["a" /* default */].reset(frameRef.value);

            case 5:
              Object.assign(form, Object(__WEBPACK_IMPORTED_MODULE_4__useAppearance__["c" /* defaultForm */])(config));
              Object.assign(previews, Object(__WEBPACK_IMPORTED_MODULE_4__useAppearance__["d" /* defaultPreviews */])(config));

            case 7:
              _context2.prev = 7;
              resetting.value = false;
              return _context2.finish(7);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2,, 7, 10]]);
    }));
    return _reset.apply(this, arguments);
  }

  return {
    submitting: submitting,
    resetting: resetting,
    errors: errors,
    save: save,
    reset: reset
  };
}

/***/ }),

/***/ 1310:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',{attrs:{"full-width":true}},[_c('form',{staticClass:"row mx-0 show active",attrs:{"slot":"tabContent","novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.handleSubmit($event)}},slot:"tabContent"},[_c('div',{staticClass:"col px-0 pr-lg-3"},[_c('div',{staticClass:"bg-white rounded mb-4 p-3"},[_c('page-heading',[_vm._v(_vm._s(_vm.config.title))]),_vm._v(" "),_c('section',{staticClass:"mb-4"},[_c('span',{staticClass:"d-block mb-3"},[_vm._v("1. Upload a sponsors' logo.")]),_vm._v(" "),_c('div',{staticClass:"f-form"},_vm._l((_vm.config.logoCount),function(n){return _c('div',{key:n,staticClass:"f-form__half f-form__half--xl"},[_c('f-file',{attrs:{"id":("sponsorLogo" + n),"label":n === 1 ? 'Sponsor Logo' : ("Sponsor Logo " + n),"accept":"image/jpeg,image/png,image/gif","hint":"Maximum recommended file size 2MB","max-size":2097152,"display-name":_vm.localFiles[("sponsor_logo_" + n)] ? _vm.localFiles[("sponsor_logo_" + n)].name : '',"is-invalid":!!_vm.errors[("sponsor_logo_" + n)],"tooltip":_vm.errors[("sponsor_logo_" + n)] ? _vm.errors[("sponsor_logo_" + n)][0] : null},on:{"change":function($event){return _vm.onFileChange(("sponsor_logo_" + n), $event)}}}),_vm._v(" "),_c('f-image-preview',{attrs:{"src":_vm.localPreviews[("sponsor_logo_" + n)] || _vm.previews[("sponsor_logo_" + n)] || null,"alt":"Sponsor Logo","deletable":!_vm.localPreviews[("sponsor_logo_" + n)] && !!_vm.previews[("sponsor_logo_" + n)],"deleting":_vm.deletingKey === ("sponsor_logo_" + n)},on:{"delete":function($event){return _vm.deleteImage(("sponsor_logo_" + n))}}}),_vm._v(" "),(_vm.config.hasLogoLinks)?_c('f-text',{attrs:{"id":("sponsorLogo" + n + "Link"),"label":("Sponsor Logo " + n + " Link"),"value":_vm.form[("sponsor_logo_" + n + "_link")],"error":_vm.errors[("sponsor_logo_" + n + "_link")] ? _vm.errors[("sponsor_logo_" + n + "_link")][0] : null},on:{"input":function($event){_vm.form[("sponsor_logo_" + n + "_link")] = $event}}}):_vm._e()],1)}),0)]),_vm._v(" "),_c('section',{staticClass:"mb-4"},[_c('span',{staticClass:"d-block mb-3"},[_vm._v("2. Change the colour scheme of the "+_vm._s(_vm.config.title.replace(' Appearance', ''))+" area to custom one.")]),_vm._v(" "),_c('div',{staticClass:"f-form"},[_c('div',{staticClass:"f-form__half f-form__half--xl"},[_c('f-color',{attrs:{"id":"schemaColor","label":"Select accent color","value":_vm.form.schema_color,"error":_vm.errors.schema_color ? _vm.errors.schema_color[0] : null},on:{"input":function($event){_vm.form.schema_color = $event}}})],1)])]),_vm._v(" "),_c('section',{staticClass:"mb-4"},[_c('span',{staticClass:"d-block mb-3"},[_vm._v("3. Upload advertisement banner.")]),_vm._v(" "),_c('div',{staticClass:"f-form"},[_c('div',{staticClass:"f-form__half f-form__half--xl"},[_c('f-file',{attrs:{"id":"sponsorLogoDesktop","label":"Sponsor Banner Desktop","accept":"image/jpeg,image/png,image/gif","hint":"Maximum recommended file size 2MB","max-size":2097152,"display-name":_vm.localFiles.sponsor_logo_desktop ? _vm.localFiles.sponsor_logo_desktop.name : '',"is-invalid":!!_vm.errors.sponsor_logo_desktop,"tooltip":_vm.errors.sponsor_logo_desktop ? _vm.errors.sponsor_logo_desktop[0] : null},on:{"change":function($event){return _vm.onFileChange('sponsor_logo_desktop', $event)}}}),_vm._v(" "),(_vm.localPreviews.sponsor_logo_desktop || _vm.previews.sponsor_logo_desktop)?_c('f-image-preview',{attrs:{"src":_vm.localPreviews.sponsor_logo_desktop || _vm.previews.sponsor_logo_desktop,"alt":"Banner Desktop","deletable":!_vm.localPreviews.sponsor_logo_desktop && !!_vm.previews.sponsor_logo_desktop,"deleting":_vm.deletingKey === 'sponsor_logo_desktop'},on:{"delete":function($event){return _vm.deleteImage('sponsor_logo_desktop')}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"f-form__half f-form__half--xl"},[_c('f-file',{attrs:{"id":"sponsorLogoMobile","label":"Sponsor Logo Mobile","accept":"image/jpeg,image/png,image/gif","hint":"Maximum recommended file size 2MB","max-size":2097152,"display-name":_vm.localFiles.sponsor_logo_mobile ? _vm.localFiles.sponsor_logo_mobile.name : '',"is-invalid":!!_vm.errors.sponsor_logo_mobile,"tooltip":_vm.errors.sponsor_logo_mobile ? _vm.errors.sponsor_logo_mobile[0] : null},on:{"change":function($event){return _vm.onFileChange('sponsor_logo_mobile', $event)}}}),_vm._v(" "),(_vm.localPreviews.sponsor_logo_mobile || _vm.previews.sponsor_logo_mobile)?_c('f-image-preview',{attrs:{"src":_vm.localPreviews.sponsor_logo_mobile || _vm.previews.sponsor_logo_mobile,"alt":"Banner Mobile","deletable":!_vm.localPreviews.sponsor_logo_mobile && !!_vm.previews.sponsor_logo_mobile,"deleting":_vm.deletingKey === 'sponsor_logo_mobile'},on:{"delete":function($event){return _vm.deleteImage('sponsor_logo_mobile')}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"f-form__half f-form__half--xl"},[_c('f-text',{attrs:{"id":"sponsorLink","label":"Sponsor Link","value":_vm.form.sponsor_link,"error":_vm.errors.sponsor_link ? _vm.errors.sponsor_link[0] : null},on:{"input":function($event){_vm.form.sponsor_link = $event}}})],1)])])],1),_vm._v(" "),_c('mobile-submit-button',{attrs:{"loading":_vm.submitting || _vm.loading}},[_vm._v("\n        Save\n      ")])],1),_vm._v(" "),_c('desktop-action-bar',[_c('app-button',{staticClass:"px-md-5",attrs:{"type":"submit","loading":_vm.submitting || _vm.loading}},[_vm._v("\n        Save\n      ")]),_vm._v(" "),_c('app-button',{staticClass:"mt-2",attrs:{"variant":"outline-primary","size":"sm","loading":_vm.resetting || _vm.loading},on:{"click":_vm.handleReset}},[_vm._v("\n        Reset\n      ")])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/10.64257e533ca3c3c6bdb0.js